import {ThumbnailTarget, UpdateThumbnailResult} from '../types';
import {usePost} from './../useHttpHooks';

export type UpdateThumbnailCommand = {
    target: ThumbnailTarget;
    id: string;
    // The picture as a data URL.
    src: string;
};

const useUpdateThumbnail = () =>
    usePost<UpdateThumbnailCommand, UpdateThumbnailResult>(
        `/api/thumbnails/update`,
        {errorMessage: 'POST api/thumbnails/update failed'}
    );

export default useUpdateThumbnail;
